



















































import { computed, defineComponent, ref } from "@vue/composition-api";
import { ContentPriceSubject, ContentPriceSubjectTypeEnum } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { PurchaseSubjectTypeEnum } from "@scrile/api-provider/dist/api/PurchaseTypeProvider";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { EventPostStatus } from "@scrile/api-provider/dist/projects/scrileConnect/EventPostProvider";
import useOneTimePurchase from "@/hooks/useOneTimePurchase";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { getFullPriceData } from "@/lib/moneyHelpers";
import { PurchaseDetails } from "@/payments/types";
import { EVENTS, PurchaseType } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import FormatMoney from "@/components/FormatMoney";
import PaymentConfirmation from "@/components/PaymentConfirmation";
import { PaymentConfirmationData } from "@/components/PaymentConfirmation/const";
import UserSubscribeModal from "../UserSubscribeModal";

export default defineComponent({
  name: "EventTicketPurchaseModal",
  components: { PaymentConfirmation, UserSubscribeModal, BaseButton, BaseConfirm, FormatMoney },
  props: {
    show: { type: Boolean, default: false },
    contentFeed: { type: Object as () => ContentFeed },
    paymentPackages: { type: Array as () => PaymentPackage[], required: true },
  },

  setup(props, { emit }) {
    const openPaymentConfirm = ref(false);
    const purchaseProcessing = ref(false);
    const paymentSystemId = ref("");

    const priceData = computed(() =>
      getFullPriceData(props.paymentPackages.find(i => i.id === props.contentFeed?.details.event?.ticketPricePackageId))
    );

    const minimumSubscriptionLevelId = computed(() => props.contentFeed?.details.event?.minimumLevelId);

    const isOnlyPrice = computed(
      () =>
        props.contentFeed?.details.event?.minimumLevelId === "0" &&
        props.contentFeed?.details.event?.ticketPricePackageId !== "0"
    );

    const isEventStarted = computed(
      () =>
        props.contentFeed?.details?.event?.status === EventPostStatus.READY_TO_START ||
        props.contentFeed?.details?.event?.status === EventPostStatus.STARTED
    );

    const data = computed<ContentPriceSubject>(() => ({
      subjectId: props.contentFeed?.id ?? "0",
      subjectType: ContentPriceSubjectTypeEnum.EVENT,
    }));

    const purchaseDetails = computed<PurchaseDetails>(() => ({
      pricePackageId: props.contentFeed?.details.event?.ticketPricePackageId ?? "0",
      price: priceData.value.price,
      paymentSystemId: paymentSystemId.value,
      subject: {
        subjectId: props.contentFeed?.id ?? "0",
        subjectType: PurchaseSubjectTypeEnum.EVENT,
      },
    }));

    const { performOneTimePurchase } = useOneTimePurchase(data, purchaseDetails);

    const handleOneTimePurchase = async (data: PaymentConfirmationData) => {
      try {
        if (!props.contentFeed) return;
        purchaseProcessing.value = true;
        paymentSystemId.value = data.paymentSystemId ?? "";
        const response = await performOneTimePurchase(data.fromBalance);

        if (response.success) {
          emitter.emit(EVENTS.NOTIFICATION_SHOW, {
            text: $t("One time buy {0} content for {1}", [
              props.contentFeed?.user.screenName,
              data.fromBalance ? priceData.value.creditPrice : priceData.value.price,
            ]),
            image: { user: props.contentFeed?.user },
            button: { text: $t("Close") },
            position: "top",
          });
          emit("book");
        }
      } finally {
        purchaseProcessing.value = false;
      }
    };

    const onClose = () => {
      if (purchaseProcessing.value) return;
      if (isOnlyPrice.value) {
        emit("close");
      }
      openPaymentConfirm.value = false;
      paymentSystemId.value = "";
    };

    return {
      priceData,
      isOnlyPrice,
      purchaseProcessing,
      minimumSubscriptionLevelId,
      isEventStarted,
      openPaymentConfirm,
      PurchaseType,
      handleOneTimePurchase,
      onClose,
    };
  },
});
